(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pnoy-subscribe-modal"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pnoy-subscribe-modal')) {
    customElements.define('pnoy-subscribe-modal', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        const trigger = this.querySelector('[data-pnoy-subscribe-open]');
        const dialog = this.querySelector('dialog');
        const close = this.querySelector('[data-pnoy-subscribe-close]');
        const dismiss = this.querySelector('[data-pnoy-subscribe-dismiss]');
        if (!trigger || !close || !dismiss || !dialog || typeof dialog.showModal !== 'function') return;

        this.initialized = true;
        this.dialog = dialog;
        trigger.addEventListener('click', () => {
          if (dialog.open) return;
          dialog.showModal();
          close.focus({ preventScroll: true });
        });
        close.addEventListener('click', () => dialog.close());
        dismiss.addEventListener('click', () => dialog.close());
        close.addEventListener('keydown', (event) => {
          if (event.key === 'Tab' && event.shiftKey) {
            event.preventDefault();
            dismiss.focus();
          }
        });
        dismiss.addEventListener('keydown', (event) => {
          if (event.key === 'Tab' && !event.shiftKey) {
            event.preventDefault();
            close.focus({ preventScroll: true });
          }
        });
        dialog.addEventListener('close', () => {
          if (trigger.isConnected) trigger.focus({ preventScroll: true });
        });
        trigger.disabled = false;
      }

      disconnectedCallback() {
        if (this.dialog?.open) this.dialog.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
